<template>
    <div class="col no-pad map-wrapper">
        <div id="layer-control" class="btn-group" role="group" aria-label="Basic example" v-if="route.data.route">
            <button @click="toggleTrafficLayer()" type="button" class="btn btn-primary">Verkehrslage</button>
            <button @click="toggleSidebar()" type="button" class="btn btn-secondary">
                <span v-if="route.showSidebar">Route ausblenden</span>
                <span v-else>Route einlenden</span>
            </button>
        </div>
        <google-map :center="center" :zoom="15" ref="map" :options="mapOptions" style="width: 100%; height: 100%">
            <button @click="toggleTrafficLayer()"></button>
            <google-cluster :gridSize="undefined" :maxZoom="mapOptions.maxZoom" :minimumClusterSize="3" :styles="undefined" :zoomOnClick="true">
                <google-marker :key="i" v-for="(station,i) in stations" :position="station.location" :clickable="true" :draggable="false" :icon="getMarkerIcon(station.mts_brand)" @click="openInfoWindowTemplate(station, station.tid)">
                </google-marker>
            </google-cluster>
            <google-marker v-if="!(Object.keys(placeMarker.location).length === 0)" :position="placeMarker.location" ref="placeMarker" :clickable="false" :draggable="false"></google-marker>
            <gmap-info-window :options="{maxWidth: 300}" :position="infoWindow.position" :opened="infoWindow.open" @closeclick="infoWindow.open=false">
                <div v-if="infoWindow.dataLoaded">
                    <div id="iw-container" :class="infoWindow.template.mts_brand.toLowerCase()">
                        <div class="iw-title">{{infoWindow.template.tankstelle}}</div>
                        <div class="iw-content">
                            <div class="iw-subTitle">Kontakt</div>
                            <div class="iw-address">
                                <address>
                                    <strong>{{infoWindow.template.tankstelle}}</strong>
                                    <br> {{infoWindow.template.address.street}} {{infoWindow.template.address.street_number}}
                                    <br> {{infoWindow.template.address.zip}} {{infoWindow.template.address.city}}
                                    <br>
                                    <strong title="Telefon" v-if="infoWindow.template.contact.phone"><i class="fa fa-phone"></i></strong>&emsp;{{infoWindow.template.contact.fax}}
                                    <br>
                                    <strong title="Fax" v-if="infoWindow.template.contact.fax"><i class="fa fa-fax"></i></strong>&emsp;{{infoWindow.template.contact.phone}}
                                    <br>
                                    <a :href="`mailto: ${infoWindow.template.contact.email}`" v-if="infoWindow.template.contact.email">
                                        <strong title="E-Mail"><i class="fa fa-envelope"></i></strong>&emsp;{{infoWindow.template.contact.email}}
                                    </a>
                                </address>
                                <hr>
                            </div>

                            <div class="iw-info">
                                <div class="iw-subTitle">Zahlarten</div>
                                <span class="badge badge-primary" v-for="method in infoWindow.template.payment_methodes">{{method.display_name}}</span>
                                <div class="iw-subTitle">Kraftstoffe</div>
                                <span class="badge badge-primary" v-for="fuel in infoWindow.template.fuel">{{fuel.display_name}}</span>
                                <hr>
                            </div>
                            <button v-if="position" class="btn bt-primary" @click="getRoute(infoWindow.position)">
                                Route
                            </button>
                            <a :href="
                          `${baseUrl}/tankstelle.html?--w4_sprintstations-joblist[@package]=w4.sprintstations&--w4_sprintstations-joblist[@controller]=station&--w4_sprintstations-joblist[@action]=show&--w4_sprintstations-joblist[@format]=html&--w4_sprintstations-joblist[station][__identity]=${infoWindow.template.tid}`" class="btn btn-primary">Detailseite</a>
                        </div>
                    </div>
                </div>
            </gmap-info-window>
        </google-map>
    </div>
</template>
<script>
    import Vue from 'vue'
    import { mapActions, mapGetters } from 'vuex'
    import mapStyles from './mapStyles'
    import { loaded } from 'vue2-google-maps'

    export default {
        name: 'g-map',
        components: {},
        props: [],
        data() {
            return {
                baseUrl: window.location.origin,
                center: {
                    lat: 52,
                    lng: 13
                },
                position: null,
                infoWindow: {
                    location: { lat: 0, lng: 0 },
                    open: false,
                    template: {},
                    currentMidx: 0,
                    dataLoaded: false
                },
                placeMarker: {
                  location: {}
                },
                mapOptions: {
                    styles: mapStyles,
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: true,
                    streetViewControl: true,
                    rotateControl: false,
                    fullscreenControl: true,
                    maxZoom: 15
                },
                travelMode: 'DRIVING'
            }
        },
        mounted() {
            loaded.then(() => {
                this.initMap()
                if (this.selectedPlace) {
                    this.showSelectedPlace(this.selectedPlace)
                    this.clearSearch()
                }
                else if (this.selectedStation) {
                    this.showSelectedStation(this.selectedStation)
                    this.clearSearch()
                }
                else {
                    if (this.location.data) {
                        this.center = this.location.data
                        this.position = this.location.data
                        this.findClosestStation(this.position)
                    } else {
                        this.center = {lat: 52.520008, lng: 13.404954}
                        //this.position = {lat: 52.520008, lng: 13.404954}
                        this.setMapBounds()
                    }
                }
                this.closeSidebar()
                this.clearRouteStore()
            })
        },
        created() {

        },
        methods: {
            ...mapActions([
                'clearSearch',
                'setSelectedStation',
                'setRoute',
                'clearRouteStore',
                'toggleSidebar',
                'closeSidebar'
            ]),
            initMap() {
                this.directionsService = new google.maps.DirectionsService()
                this.directionsDisplay = new google.maps.DirectionsRenderer()
                this.trafficLayer = new google.maps.TrafficLayer()
                //this.setMapBounds()
            },
            toggleTrafficLayer() {
                if (this.trafficLayer.getMap()) {
                    this.trafficLayer.setMap(null)
                } else {
                    this.trafficLayer.setMap(this.$refs.map.$mapObject)
                }
            },
            findClosestStation (location) {
                let bounds = new google.maps.LatLngBounds()
                bounds.extend(location)

                let markerLocation = {
                    geometry: {
                        location: {
                            lat: location.lat,
                            lng: location.lng
                        }
                    }
                }

                let nearestStation = this.findClosestMarker(markerLocation)
                this.placeMarker.location = location
                bounds.extend(new google.maps.LatLng(nearestStation.location.lat, nearestStation.location.lng))
                this.$refs.map.$mapPromise.then((map) => {
                    map.fitBounds(bounds)
                    map.panToBounds(bounds)
                })
            },
            findClosestMarker(place) {
                let placeLatLng
                let closestStation
                let closestDistance = Number.MAX_VALUE

                this.stations.forEach((station) => {

                    if (!isNaN(place.geometry.location.lat) && place.geometry.location.lat.toString().indexOf('.') != -1) {
                        placeLatLng = new google.maps.LatLng({lat: place.geometry.location.lat, lng: place.geometry.location.lng})
                    } else {
                        placeLatLng = place.geometry.location
                    }

                    let distance = this.calculateDistance(placeLatLng, new google.maps.LatLng({lat:station.location.lat, lng: station.location.lng}))

                    if (distance < closestDistance) {
                        closestStation = station
                        //console.log(closestStation)
                        closestDistance = distance
                        //console.log(closestDistance)
                    }
                })
                //console.log('NearestStation: ', closestStation)
                return closestStation
            },
            calculateDistance(a, b) {
                return google.maps.geometry.spherical.computeDistanceBetween(a, b)
            },
            openInfoWindowTemplate(marker, idx) {
                this.infoWindow.dataLoaded = false
                this.infoWindow.template = marker
                this.infoWindow.position = marker.location
                this.infoWindow.dataLoaded = true
                this.infoWindow.open = true
                this.updateCenter(marker.location)
                //check if its the same marker that was selected if yes toggle
                if (this.currentMidx === idx) {
                    this.infoWinOpen = !this.infoWinOpen;
                } else {
                    this.infoWinOpen = true;
                    this.currentMidx = idx;
                }
            },
            updateCenter(center) {
                this.center = {
                    lat: center.lat,
                    lng: center.lng
                }
                this.$refs.map.panBy(this.center.lat, this.center.lng)
            },
            getRoute(location) {
                this.infoWindow.open = false
                this.clearRoute()
                this.directionsDisplay.setMap(this.$refs.map.$mapObject)

                let vm = this
                vm.directionsService.route({
                    origin: this.position,
                    destination: location,
                    travelMode: this.travelMode
                }, function(response, status) {
                    if (status === 'OK') {
                        vm.$store.commit('SHOW_SIDEBAR')
                        Vue.$gmapDefaultResizeBus.$emit("resize")
                        vm.setRoute(response)
                        vm.directionsDisplay.setPanel(document.getElementById('route-container'))
                        vm.directionsDisplay.setDirections(response)
                        vm.$refs.map.fitBounds(response.routes[0].bounds)
                        Vue.$gmapDefaultResizeBus.$emit("resize")
                    } else {
                        console.log('Directions request failed due to ' + status)
                    }
                })
            },
            clearRoute() {
                this.directionsDisplay.setMap(null)
                this.directionsDisplay.setPanel(null)
                this.clearRouteStore()
            },
            showSelectedStation(station) {
                let bounds = new google.maps.LatLngBounds()
                bounds.extend(new google.maps.LatLng(station.location.lat, station.location.lng))

                //this.updateCenter(station.location)
                this.openInfoWindowTemplate(station, station.tid)

                this.$refs.map.$mapPromise.then((map) => {
                    map.fitBounds(bounds)
                    map.panToBounds(bounds)
                })
                Vue.$gmapDefaultResizeBus.$emit("resize")
            },
            showSelectedPlace(place) {
                let bounds = new google.maps.LatLngBounds()
                bounds.extend(place.geometry.location)
                let nearestStation = this.findClosestMarker(place)
                bounds.extend(new google.maps.LatLng(nearestStation.location.lat, nearestStation.location.lng))

                this.placeMarker.location = place.geometry.location

                this.$refs.map.$mapPromise.then((map) => {
                    map.fitBounds(bounds)
                    map.panToBounds(bounds)

                    this.infoWindow.dataLoaded = false
                    this.infoWindow.template = nearestStation
                    this.infoWindow.position = nearestStation.location
                    this.infoWindow.dataLoaded = true
                    this.infoWindow.open = true
                    //check if its the same marker that was selected if yes toggle
                    if (this.currentMidx === nearestStation.tid) {
                        this.infoWinOpen = !this.infoWinOpen
                    } else {
                        this.infoWinOpen = true;
                        this.currentMidx = nearestStation.tid
                    }
                })
                Vue.$gmapDefaultResizeBus.$emit("resize")

                this.clearSearch()
            },
            setMapBounds() {
                let bounds = new google.maps.LatLngBounds();

                this.stations.forEach(station => {
                    bounds.extend(new google.maps.LatLng(station.location.lat, station.location.lng));
                })

                this.$nextTick(() => {
                    this.$refs.map.$mapPromise.then((map) => {
                        map.fitBounds(bounds)
                        map.panToBounds(bounds)
                    })
                })

                Vue.$gmapDefaultResizeBus.$emit("resize")
            },
            getMarkerIcon(mts_brand) {
                switch (mts_brand.toLowerCase()) {
                    case 'go':
                        return 'https://maps.gstatic.com/mapfiles/ms2/micons/blue-dot.png'
                        break;
                    case 'sprint':
                        return 'https://maps.gstatic.com/mapfiles/ms2/micons/red-dot.png'
                        break;
                    case 'sb-markttankstelle':
                        return 'https://maps.gstatic.com/mapfiles/ms2/micons/orange-dot.png'
                        break;
                    default:
                        return 'https://maps.gstatic.com/mapfiles/ms2/micons/red-dot.png'
                }
            }
        },
        computed: {
            ...mapGetters({
                location: 'location',
                stations: 'filteredStations',
                route: 'route',
                selectedStation: 'selectedStation',
                selectedPlace: 'selectedPlace'
            })
        },
        watch: {
            stations (newStations, oldStations) {
                this.setMapBounds()
            },
            selectedStation(station) {
                if (this.selectedStation) {
                    console.log('Station changed', station)
                    this.showSelectedStation(station)
                }
            },
            selectedPlace(place) {
                if (this.selectedPlace) {
                    console.log('Place changed', place)
                    this.showSelectedPlace(place)
                }
            }
        }
    }
</script>
<style lang="scss">
    /**
       * GoogleMap InfoWindow
       */

    .gm-style-iw {
        width: 100% !important;
        min-width: 300px !important;
        top: 0px !important;
        left: 0px !important;
        background-color: transparent;

        div {
            max-width: 100% !important;
            width: 100% !important;
            max-height: 100% !important;
        }
    }

    #iw-container {
        margin-bottom: 10px;

        &.go {
            .iw-title {
                background-color: rgba(0, 48, 135, 1);
            }
            .badge-primary {
                background-color: rgba(0, 48, 135, 1);
            }
            .btn-primary {
                background-color: rgba(0, 48, 135, 1);
                border-color: transparent;
            }
        }

        &.sb-markttankstelle {
            .iw-title {
                background-color: rgba(255, 96, 41, 1);
            }
            .badge-primary {
                background-color: rgba(255, 96, 41, 1);
            }
            .btn-primary {
                background-color: rgba(255, 96, 41, 1);
                border-color: transparent;
            }
        }

        i {
            width: 1rem;
        }
    }

    #iw-container .iw-title {
        font-family: 'Open Sans', sans-serif;
        font-size: 22px;
        font-weight: 500;
        padding: 10px;
        background-color: #BA0C2F;
        color: white;
        margin: 0;
        border-radius: 2px 2px 0 0;
    }

    #iw-container .iw-content {
        font-size: 13px;
        line-height: 18px;
        font-weight: 400;
        margin-right: 1px;
        padding: 15px 5px 20px 15px;
        max-height: 140px;
        overflow-y: auto;
        overflow-x: hidden;
    }

    .iw-content img {
        float: right;
        margin: 0 5px 5px 10px;
    }

    .iw-subTitle {
        font-size: 16px;
        font-weight: 700;
        padding: 5px 0;
    }
</style>



// WEBPACK FOOTER //
// stationMap.vue?a988f2b4